import React from 'react';
import { useDispatch } from 'react-redux';

import './FavouriteFarmEdit.scss';

import {
  addFarmToFavourites,
  removeFarmFromFavourites,
} from '../../reducers/favouriteFarmsSlice';
import Icon from '../../common/components/IconSvg/Icon';

export default function FavouriteFarmEdit({ farmId, isFarmFavourite }) {
  const dispatch = useDispatch();
  const iconName = isFarmFavourite
    ? 'lely-icon-star-filled'
    : 'lely-icon-star-empty';

  return (
    <span
      className="favourite-farm-edit"
      onClick={(e) => {
        e.stopPropagation(); // skip propagation in order not to navigate to the farm on current line after clicking
        // dispatch add this farm to favourite (possibly make a request to the backend here)
        if (isFarmFavourite) {
          dispatch(removeFarmFromFavourites(farmId));
        } else {
          dispatch(addFarmToFavourites(farmId));
        }
      }}
    >
      <Icon
        name={iconName}
        style={{ color: '#646060' }}
        width={20}
        height={20}
      />
    </span>
  );
}
